import React, {Fragment, Component} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {Grid, Responsive, Modal, Button, Dimmer, Header, Menu, Icon, Container, Segment, Image} from 'semantic-ui-react';
import {Redirect} from 'react-router-dom';


export default function Footer(){

  //<br/>
  //<br/>
  //<a href="mailto:support@glados.network" style={{color:"#eee"}}>Support Email: support@glados.network</a>
  return (
    <div id="footer" size='large' style={{border:"0px",background:"#2c5282",marginTop: '20em', padding: '4em 2em'}} >
      <Container >
        <Grid>
          <Grid.Row>
            <Grid.Column style={{marginTop:"1em"}} >

              <Responsive minWidth={1080}>
                <Link to="/console/client" style={{color:"#fff"}}>Customer Service / Refund</Link>
                <span>&nbsp; &nbsp; &nbsp;</span>
                <br/>
                <br/>
                <Link to="/console/security" style={{color:"#fff"}}>Security and Regulation</Link>
                <span>&nbsp; &nbsp; &nbsp;</span>
                <br/>
                <br/>
                <Link to="/console/giftcard" style={{color:"#fff"}}>Giftcard</Link>
                <br/>
                <br/>
                <Link to="/console/education" style={{color:"#fff"}}>Education Plan</Link>
                <br/>
                <br/>
                <Link to="/console/monitor" style={{color:"#fff"}}>Speedtest</Link>
                <br/>
                <br/>
                <Link to="/console/notification" style={{color:"#fff"}}>Changelog</Link>
              </Responsive>

              <img src="/images/logo-trans-01.png"  className="logos" style={{width:"20em",float:"right",textAlign: 'center', marginBottom: '4em', marginTop:"-5em"}}/>

              <p style={{marginTop:"4em",marginBottom:"1.5em"}}/>
              <p>
                <b  style={{color:"#eee",fontSize:"1em"}}>General Local and Destination Operating System</b>
              </p>
              <p>
                <b  style={{color:"#ddd",fontSize:"1em"}}>GLaDOS LLC. All Rights Reserved. </b>
              </p>

            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </div>
  )
}

